import { render } from "./_ChatPageLayout.vue?vue&type=template&id=611db7d7"
import script from "./_ChatPageLayout.vue?vue&type=script&lang=js"
export * from "./_ChatPageLayout.vue?vue&type=script&lang=js"

import "@/css/chatbot.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__